<template>
  <div class="jin-pc-resume jin-pc jin-pc-height">
    <div class="jin-resume-con">
      <Breadcrumb />
      <div class="jin-resume-warp">
        <PostHead show />
        <div class="jin-resume-tab-con">
          <div v-sticky="{ zIndex: 100, stickyTop: 60}" class="jin-resume-tab-warp">
            <span v-for="item in tabs" :key="item.type" class="jin-resume-tab-item" :class="{'jin-resume-tab-item-active' : item.type === tabActive }" @click="handleTab(item)">{{ item.name }}</span>
          </div>
          <div v-if="tabActive === 'online'" class="jin-resume-form">
            <SideBar :head-info="online.con" :active="online.active" />
            <FormWarp @onActive="onActive" />
          </div>
          <div v-if="tabActive === 'upload'" class="jin-resume-upload">
            <SideBar :head-info="upload.con" :active="upload.active" />
            <UploadWarp @onActive="onActive" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky'
import resume from '../components/option'
import FormWarp from '../components/FormWarp'
import UploadWarp from '../components/UploadWarp'
import { mapGetters } from 'vuex'

export default {
  directives: {
    'sticky': VueSticky
  },
  components: {
    FormWarp,
    UploadWarp
  },
  data() {
    return {
      online: resume.online,
      upload: resume.upload,
      tabActive: 'online',
      tabs: [
        {
          name: '在线编辑简历',
          type: 'online'
        }, {
          name: '上传简历投递',
          type: 'upload'
        }]
    }
  },
  computed: {
    ...mapGetters([
      'resumeCon'
    ]),
    type() {
      return this.$route.query.type
    }
  },
  watch: {
    type() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.type) {
        this.tabActive = this.type
      }
    },
    onActive(active, key) {
      this[key].active = active
    },
    handleTab(item) {
      this.$router.replace({
        path: '/list/resume',
        query: {
          ...this.$route.query,
          type: item.type
        }
      })
      this.tabActive = item.type
    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-pc {
    &-resume {
      background: #f4f5f9;
    }
  }

  /deep/ &-post-head-warp {
    padding: 40px 0;
  }

  &-resume {
    &-con {
      width: 1000px;
      margin: 0 auto;
    }

    &-warp {
      /deep/ .jin-post-head {
        padding: 0 40px;

        &-warp {
          border: none;
        }
      }
    }

    &-tab {
      &-con {
        background: #fff;
        margin-top: 20px;
      }

      &-warp {
        background: #fff;
        padding: 20px 55px 0;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #e8e8ea;
      }

      &-item {
        cursor: pointer;
        padding: 20px;
        height: auto;
        color: #787b8a;
        line-height: 25px;
        font-size: 18px;

        &-active {
          font-weight: 500;
          color: #4777f4;
          position: relative;

          &::after {
            content: '';
            position: absolute;
            height: 2px;
            width: 40px;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
            background: #4777f4;
          }
        }
      }
    }

    &-form,
    &-upload {
      display: flex;
      justify-content: space-between;
      position: relative;
    }
  }
}
</style>
